import { ICommandBase } from '@/commands/interface/iCommandBase';
import { ExTextLayer } from '@/model/document2/page/surface/design/layer/exTextLayer';
import { TextInfo } from '@/utilityModels/textInfo';

// 通常テキストレイヤーの文法情報全変更コマンド
export class ChangePlainTextLayerWholeTextInfoCommand implements ICommandBase
{
    private layer! : ExTextLayer;
    private propertyName! : string;
    private value! : any;
    private doneCallback! : () => void;

    private oldTextInfoArray;
    private oldBaseTextInfo;

    constructor(layer : ExTextLayer, propertyName : string, value : any, doneCallback : () => void)
    {
        this.layer = layer;
        this.propertyName = propertyName;
        this.value = value;
        this.doneCallback = doneCallback;

        // 現在の値を保持
        this.oldTextInfoArray = layer.textInfoArray;
        this.oldBaseTextInfo = layer.baseTextInfo;
    }

    public do() : void
    {
        var newBaseTextInfo = this.layer.baseTextInfo.clone();
        newBaseTextInfo[this.propertyName] = this.value;
        // 新しい値を設定
        this.layer.baseTextInfo = newBaseTextInfo;
        
        if(this.layer.textInfoArray.length > 0)
        {
            var newTextInfoArray = new Array();
            for(var textInfo of this.layer.textInfoArray)
            {
                var newTextInfo = textInfo.clone();
                newTextInfo[this.propertyName] = this.value;
                newTextInfoArray.push(newTextInfo);
            }
            var newBaseTextInfo = this.layer.baseTextInfo.clone();
            // 新しい値を設定
            this.layer.textInfoArray = newTextInfoArray;
        }

        this.doneCallback();
    }

    public undo() : void
    {
        // プロパティに前の値を設定
        this.layer.textInfoArray = this.oldTextInfoArray;
        this.layer.baseTextInfo = this.oldBaseTextInfo;

        this.doneCallback();
    }

    public redo() : void
    {
        var newBaseTextInfo = this.layer.baseTextInfo.clone();
        newBaseTextInfo[this.propertyName] = this.value;
        // 新しい値を設定
        this.layer.baseTextInfo = newBaseTextInfo;
        
        if(this.layer.textInfoArray.length > 0)
        {
            var newTextInfoArray = new Array();
            for(var textInfo of this.layer.textInfoArray)
            {
                var newTextInfo = textInfo.clone();
                newTextInfo[this.propertyName] = this.value;
                newTextInfoArray.push(newTextInfo);
            }
            var newBaseTextInfo = this.layer.baseTextInfo.clone();
            // 新しい値を設定
            this.layer.textInfoArray = newTextInfoArray;
        }

        
        this.doneCallback();
    }
}